import request from "./request";

const QuestionsService = {
    GetAllQuestions: async (context, signal) => {
        return await request.sendRequest(`/Questions/all`, context.token, signal);
    },
    GetAllAnswers: async (context, signal) => {
        return await request.sendRequest(`/Questions/answers`, context.token, signal);
    },
    Save: async (body, context, signal) => {
        return await request.sendPostRequest(`/Questions`, body, context, signal);
    },
};

export default QuestionsService;
